import { useState, createContext } from 'react';

const INITIAL_VALUES = {
  isLoading: false,
  setIsLoading: (v) => {},
  modalOpened: false,
  setModalOpened: (v) => {},
  modalOpenedCashIn: false,
  setModalOpenedCashIn: (v) => {},
  fetchCount: 0,
  setFetchCount: (v) => {},
  allFetchedDepartments: null,
  setAllFetchedDepartments: (v) => {},
  selectedCashId: '',
  setSelectedCashId: (v) => {},
  selectedDepartment: '',
  setSelectedDepartment: (v) => {},
  isSubmittingForm: false,
  setIsSubmittingForm: (v) => {},
  nameSearchValue: '',
  setNameSearchValue: (v) => {},
  tablePagination: {
    current_page: 1,
    per_page: 0,
    total: 0
  },
  setTablePagination: (v) => {}
};

const PaymentDepartmentContext = createContext(INITIAL_VALUES);

export const PaymentDepartmentProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(INITIAL_VALUES.isLoading);
  const [modalOpened, setModalOpened] = useState(INITIAL_VALUES.modalOpened);
  const [modalOpenedCashIn, setModalOpenedCashIn] = useState(
    INITIAL_VALUES.modalOpened
  );
  const [fetchCount, setFetchCount] = useState(INITIAL_VALUES.fetchCount);
  const [allFetchedDepartments, setAllFetchedDepartments] = useState(
    INITIAL_VALUES.allFetchedDepartments
  );

  const [selectedCashId, setSelectedCashId] = useState(
    INITIAL_VALUES.selectedCashId
  );
  const [selectedDepartment, setSelectedDepartment] = useState(INITIAL_VALUES.selectedDepartment);
  const [tablePagination, setTablePagination] = useState(
    INITIAL_VALUES?.tablePagination
  );
  const [isSubmittingForm, setIsSubmittingForm] = useState(
    INITIAL_VALUES.isSubmittingForm
  );

  return (
    <PaymentDepartmentContext.Provider
      value={{
        isLoading,
        setIsLoading,
        modalOpened,
        setModalOpened,
        fetchCount,
        setFetchCount,
        allFetchedDepartments,
        setAllFetchedDepartments,
        selectedCashId,
        setSelectedCashId,
        tablePagination,
        setTablePagination,
        selectedDepartment,
        setSelectedDepartment,
        isSubmittingForm,
        setIsSubmittingForm,
        modalOpenedCashIn,
        setModalOpenedCashIn
      }}
    >
      {children}
    </PaymentDepartmentContext.Provider>
  );
};

export default PaymentDepartmentContext;
